import {
  migrateAllPlainBrowserStorageKeys,
  NativeBrowserStorage,
} from './local-storage-encryption.util';

function createNativeBrowserStorage(storage: Storage): NativeBrowserStorage {
  return {
    getItem: Storage.prototype.getItem.bind(storage),
    setItem: Storage.prototype.setItem.bind(storage),
    removeItem: Storage.prototype.removeItem.bind(storage),
    clear: Storage.prototype.clear.bind(storage),
    key: Storage.prototype.key.bind(storage),
    get length() {
      return storage.length;
    },
  };
}

let nativeLocalStorage: NativeBrowserStorage | null = null;
let nativeSessionStorage: NativeBrowserStorage | null = null;

export function getNativeLocalStorage(): NativeBrowserStorage {
  nativeLocalStorage ??= createNativeBrowserStorage(window.localStorage);
  return nativeLocalStorage;
}

export function getNativeSessionStorage(): NativeBrowserStorage {
  nativeSessionStorage ??= createNativeBrowserStorage(window.sessionStorage);
  return nativeSessionStorage;
}

export function migrateAllPlainLocalStorageKeys(): void {
  if (typeof window === 'undefined') {
    return;
  }

  migrateAllPlainBrowserStorageKeys(
    getNativeLocalStorage(),
    getNativeSessionStorage()
  );
}
